import {
  BasicMaturity,
  CouponOption,
  CouponType
} from '../../../types/deal.types';

abstract class CouponMaturityFilterStrategy {
  public abstract apply(maturity: BasicMaturity): boolean;

  public config(model: CouponOption): void {
    //do nothing
  }
}

class ZeroCouponFilterMaturityStrategy extends CouponMaturityFilterStrategy {
  apply(maturity: BasicMaturity) {
    return maturity.coupon === 0;
  }
}

class SingleCouponFilterMaturityStrategy extends CouponMaturityFilterStrategy {
  private selectedValue: number;
  apply(maturity: BasicMaturity) {
    return maturity.coupon !== null && maturity.coupon === this.selectedValue;
  }

  public config(model: CouponOption): void {
    this.selectedValue = model.from;
  }
}

class RangeCouponFilterMaturityStrategy extends CouponMaturityFilterStrategy {
  private from: number;
  private to: number;
  apply(maturity: BasicMaturity) {
    return (
      maturity.coupon !== null &&
      maturity.coupon >= this.from &&
      maturity.coupon <= this.to
    );
  }

  public config(model: CouponOption): void {
    this.from = model.from;
    this.to = model.to;
  }
}

export class CouponMaturityLevelFilter {
  private stateStrategies = {
    [CouponType.Single]: new SingleCouponFilterMaturityStrategy(),
    [CouponType.Range]: new RangeCouponFilterMaturityStrategy(),
    [CouponType.Zero]: new ZeroCouponFilterMaturityStrategy()
  };

  private selectedStrategy: CouponMaturityFilterStrategy;

  constructor(model: CouponOption) {
    this.selectedStrategy = this.stateStrategies[model.type];

    this.selectedStrategy.config(model);
  }

  applyFilter(maturity: BasicMaturity): boolean {
    return this.selectedStrategy.apply(maturity);
  }
}
